import React from "react";

import SmartLink from "../general/SmartLink";

//Photo banner at the top of each page, with a dark tint so the white heading reads (as on Wix)
const PageHero = ({ image, title, text, button }) => (
  <section className={"page-hero"}>
    <img
      src={image.src}
      alt={""}
      width={image.width}
      height={image.height}
      className={"page-hero-image"}
    />
    <div className={"page-hero-content"}>
      <h1 className={"page-hero-title"}>{title}</h1>
      <img
        src={"/images/divider.png"}
        alt={""}
        width={106}
        height={31}
        className={"section-divider"}
      />
      {text ? <p className={"page-hero-text"}>{text}</p> : null}
      {button ? (
        <SmartLink
          path={button.path}
          href={button.href}
          className={"btn"}
        >
          {button.label}
        </SmartLink>
      ) : null}
    </div>
  </section>
);

export default PageHero;
